import { render, staticRenderFns } from "./caseItem.vue?vue&type=template&id=27bd6600&scoped=true"
import script from "./caseItem.vue?vue&type=script&lang=js"
export * from "./caseItem.vue?vue&type=script&lang=js"
import style0 from "./caseItem.vue?vue&type=style&index=0&id=27bd6600&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_398719d9ba0fb65ce1cea3b2910bec76/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bd6600",
  null
  
)

export default component.exports